import { Button } from '../../../primitives/button';
import { LoadingAddon } from '../../../primitives/loading-addon';
import { cn } from '../../../utils/cn';
import { ComboboxModel, ComboboxModelModel } from '../combobox-model';
import { getStarmanIcons } from './get-starman-icons.util';

import type { JSX } from 'react';

interface ComboboxIconProps extends Omit<
  React.ComponentPropsWithoutRef<typeof ComboboxModel>,
  'model' | 'button'
> {
  button?: {
    icon?: JSX.Element;
    id?: string;
    onClick: VoidFunction;
    text?: string;
  };
  isLoading?: boolean;
}

export function ComboboxIcon({
  button,
  disabled = false,
  id,
  isLoading = false,
  placeholder,
  searchPlaceholder,
  value,
  onSelect,
}: ComboboxIconProps) {
  const model: ComboboxModelModel = getStarmanIcons();
  return (
    <div className="relative flex w-full items-center">
      <ComboboxModel
        id={id}
        className={cn('font-medium', {
          'rounded-r-none border-r-0': button?.onClick,
        })}
        disabled={disabled || isLoading}
        model={model}
        onSelect={onSelect}
        placeholder={placeholder}
        searchPlaceholder={searchPlaceholder}
        value={value}
      />
      {button?.onClick ? (
        <Button
          id={button?.id}
          type="button"
          variant="secondary"
          className="rounded-l-none border-l-0 border-input px-4 text-sm focus-visible:relative"
          disabled={disabled || isLoading}
          onClick={button.onClick}
        >
          {button?.icon ? button.icon : null}
          {button?.text ? button.text : null}
        </Button>
      ) : null}
      {isLoading && <LoadingAddon type="plain" />}
    </div>
  );
}
